<template>
    <div v-if="list.name !== null" :class="['menu-child', list.list === null ? 'no-border': '' ]">
        <div :class="['title']" @click="handleClick(list, 2)">
            {{ list.name }}
        </div>
        <div v-if="list.list !== null" :class="['content', list.list.length > 4 ? 'gird-content' : '']">
            <div class="item" v-for="(item, index) in list.list" :key="index" @click="handleClick(item, 3, index)">
                {{ item.name }}
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "menuChild",
    props: {
        parentActiveIndex: {
            type: Number,
            default: 0
        },
        childIndex: {
            type: Number,
            default: 0
        },
        list: {
            type: Object,
            default: ()=>{}
        }
    },
    methods: {
        handleClick(item, level, index){
            let activeChildCard = 0
            if(level === 3 && item.isContent === 0) {
                activeChildCard = index
            }
            sessionStorage.setItem('parentId', this.list.parentId);
            const type = this.list.type === 2 ? 0 : this.list.type === 4 ? 2 : this.list.type === 3 ? 1 : "";
            this.$emit("activeLevel", item, this.parentActiveIndex, level, type, this.childIndex, activeChildCard)
        }
    }
}
</script>

<style lang="less" scoped>
    .child-view {
        flex-shrink: 0;
        &:nth-last-of-type(1) {
            .menu-child {
                margin-right: 0;
            }
        }
        .menu-child {
            margin-right: 55px;
            &.no-border {
                margin-right: 0;
                .title {
                    border-bottom: none;
                    margin-bottom: 0;
                }
            }
            .title {
                cursor: pointer;
                width: 100%;
                padding: 32px 0 14px;
                border-bottom: 1px solid #DFDFDF;
                font-size: 16px;
                font-weight: bold;
                margin-bottom: 14px;
                line-height: 1;
                color: #333333;
                &:hover {
                    color: #FF6900;
                }
                &.no-border {
                    border: none;
                }
            }
            .content {
                padding-right: 30px;
                &.gird-content {
                    display: grid;
                    grid-auto-flow: column;
                    grid-template-columns: repeat(2, 1fr);
                    grid-template-rows: repeat(4, 1fr);
                }
                .item {
                    white-space: nowrap;
                    font-weight: normal;
                    cursor: pointer;
                    margin-bottom: 12px;
                    margin-right: 20px;
                    color: #333333;
                    font-size: 14px !important;
                    line-height: 1;
                    &:hover {
                        color: #FF6900;
                    }
                }
            }
        }
    }

</style>
